/**
 * Whether this build shows a way to create an account.
 *
 * Mirrors `registration_is_open()` in `api/src/handlers/auth.rs` exactly, and
 * for the same reasons: unset means open, so `npm run dev` needs no
 * configuration, and anything other than a literal "true" closes it, so a typo
 * hides the sign-up rather than exposing it. The pipeline injects this from the
 * same `isRegistrationOpen(envName)` the API Lambda is configured from, so the
 * two cannot disagree within a stage.
 *
 * This is cosmetic. Hiding the form does not protect anything — the API is what
 * actually refuses, and it refuses whatever the client believes.
 */
function readRegistrationOpen(): boolean {
  const raw = import.meta.env.VITE_REGISTRATION_OPEN;
  if (raw === undefined) return true;
  return String(raw).trim().toLowerCase() === 'true';
}

const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  registrationOpen: readRegistrationOpen(),
};

/**
 * Minutes to ADD to UTC to reach the browser's local time.
 *
 * `getTimezoneOffset()` returns the opposite sign, which is a classic source of
 * off-by-one-day bugs — the negation happens here, once, so the study streak
 * rolls over at the user's midnight rather than UTC's.
 */
export function tzOffsetMinutes(): number {
  return -new Date().getTimezoneOffset();
}

export default config;
